import { useState } from "react";

import { Filters } from "./Filters";
import { PaginatedTable } from "./PaginatedTable";

import { VerticalSpacing } from "@otta/design";

export const BulkPreApproval = () => {
  const [group, setGroup] = useState<string | undefined>(undefined);
  const [isCurrentPayingCustomer, setIsCurrentPayingCustomer] = useState<
    boolean | undefined
  >(undefined);
  const [companyName, setCompanyName] = useState<string | undefined>(undefined);
  const [scrapedLocation, setScrapedLocation] = useState<string | undefined>(
    undefined
  );

  const handleGroupChange = (
    option: { value: string | undefined; label: string } | null
  ) => {
    if (option) {
      setGroup(option.value);
    }
  };

  const handleIsCurrentPayingCustomerChange = (
    option: { value?: boolean; label: string } | null
  ) => {
    if (option) {
      setIsCurrentPayingCustomer(option.value);
    }
  };

  const handleSearchFieldsChange = ({
    companyName,
    scrapedLocation,
  }: {
    companyName?: string;
    scrapedLocation?: string;
  }) => {
    setCompanyName(companyName);
    setScrapedLocation(scrapedLocation);
  };

  return (
    <VerticalSpacing>
      <Filters
        handleGroupChange={handleGroupChange}
        handleIsCurrentPayingCustomerChange={
          handleIsCurrentPayingCustomerChange
        }
        handleSearchFieldsChange={handleSearchFieldsChange}
        handleClear={() => {
          setCompanyName(undefined);
          setScrapedLocation(undefined);
        }}
      />
      <PaginatedTable
        group={group}
        isCurrentPayingCustomer={isCurrentPayingCustomer}
        companyName={companyName}
        scrapedLocation={scrapedLocation}
      />
    </VerticalSpacing>
  );
};
